module.exports = __webpack_public_path__ + "static/media/Picture4.b1268327.jpg";